/** A message for each plural category a language uses; `other` is the fallback. */
export type PluralForms = { readonly other: string } & Partial<
  Readonly<Record<Intl.LDMLPluralRule, string>>
>;

/**
 * Plural helpers for a catalog's language. `pick` chooses the form for a count; `count` also
 * puts the count, formatted for the language, in place of `#`.
 */
export function plurals(tag: string) {
  const rules = new Intl.PluralRules(tag);
  const numbers = new Intl.NumberFormat(tag);
  const pick = (count: number, forms: PluralForms): string =>
    forms[rules.select(count)] ?? forms.other;
  return {
    pick,
    count: (count: number, forms: PluralForms): string =>
      pick(count, forms).replace('#', numbers.format(count)),
  };
}
